import { useEffect, useRef, useState } from "react";
import { Zap, ScanLine, Sparkles, Gauge, Cloud, Lightbulb } from "lucide-react";

const FEATURES = [
  { icon: ScanLine, label: "Capture éclair", desc: "OCR & NFC" },
  { icon: Sparkles, label: "Débrief vocal IA", desc: "Whisper + GPT" },
  { icon: Gauge, label: "Score de signature", desc: "Synthèse du compte" },
  { icon: Cloud, label: "Sync CRM", desc: "HubSpot · Salesforce" },
];

const TIPS = [
  "Relancez un prospect chaud sous 48h : jusqu'à +50% de réponses.",
  "Un débrief vocal juste après le rendez-vous capture 3× plus de détails.",
  "Notez toujours le budget et l'échéance : les 2 meilleurs prédicteurs de signature.",
  "Posez une question ouverte de plus : elle révèle souvent la vraie objection.",
  "Envoyez votre relance avant 10h pour le meilleur taux d'ouverture.",
  "Identifiez le décideur dès le premier contact pour raccourcir le cycle.",
  "Reformulez le besoin du prospect : il se sent écouté, vous gagnez en crédibilité.",
  "Un lead capturé sur salon vaut 2 leads web : traitez-le en priorité.",
];

export const SplashScreen = ({ onDone }) => {
  const [leaving, setLeaving] = useState(false);
  const tip = useRef(TIPS[Math.floor(Math.random() * TIPS.length)]).current;

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), 4300);
    const t2 = setTimeout(() => onDone?.(), 4950);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div className={`klt-splash ${leaving ? "klt-splash-out" : ""}`} data-testid="app-splash" role="status" aria-label="Chargement de Kallitag Lead Capture">
      <div className="relative flex flex-col items-center px-6">
        <div className="klt-splash-mark">
          <Zap className="klt-splash-bolt w-14 h-14" fill="currentColor" strokeWidth={1.5} />
        </div>

        <h1 className="klt-splash-word font-heading text-white text-3xl font-extrabold tracking-tight">Kallitag</h1>
        <p className="klt-splash-sub text-sky-300/80 text-xs font-semibold tracking-[0.35em] uppercase mt-1.5">Lead Capture</p>

        <div className="mt-9 grid grid-cols-2 gap-2.5 w-[320px] max-w-[86vw]">
          {FEATURES.map((f, i) => (
            <div
              key={f.label}
              className="klt-splash-feat flex items-center gap-2.5 rounded-2xl border border-white/10 bg-white/[0.04] px-3 py-2.5"
              style={{ animationDelay: `${0.75 + i * 0.13}s` }}
              data-testid={`splash-feature-${i}`}
            >
              <span className="w-8 h-8 rounded-xl bg-sky-500/15 text-sky-300 flex items-center justify-center shrink-0">
                <f.icon className="w-4 h-4" />
              </span>
              <div className="min-w-0">
                <p className="text-white text-[12px] font-semibold leading-tight">{f.label}</p>
                <p className="text-slate-400 text-[10px] leading-tight truncate">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 w-[220px] max-w-[70vw] h-1.5 rounded-full bg-white/10 overflow-hidden">
          <div className="klt-splash-progress" />
        </div>
        <div className="klt-splash-sub mt-5 flex items-start gap-2 w-[300px] max-w-[86vw]" style={{ animationDelay: "1.1s" }} data-testid="splash-tip">
          <Lightbulb className="w-3.5 h-3.5 text-amber-300/90 mt-0.5 shrink-0" />
          <p className="text-slate-400 text-[11px] leading-snug text-left">{tip}</p>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
